// src/ShootingStar.js
import React, { useEffect, useState, useRef } from 'react';
import './ShootingStar.css';

const ShootingStar = ({ id, onComplete }) => {
  const [currentStyle, setCurrentStyle] = useState({ opacity: 0 });
  const starRef = useRef(null);

  useEffect(() => {
    // --- FASTER ANIMATION ---
    const animationDuration = Math.random() * 1.0 + 0.8; // 0.8s to 1.8s (was 2.0s to 4.5s)

    const starColor = Math.random() < 0.5 ? 'rgba(247, 146, 30, 0.9)' : 'rgba(100, 150, 255, 0.9)';
    const tailLength = Math.random() * 120 + 60; // Tail length: 60px to 180px (slightly shorter for faster look)

    let startXPercent, startYPercent, angleDeg;
    const edge = Math.floor(Math.random() * 3);

    if (edge === 0) { // Start from Top
      startXPercent = Math.random() * 100;
      startYPercent = -5; // Start slightly off-screen top
      // --- MORE DOWNWARDS ANGLE ---
      angleDeg = Math.random() * 30 + 75; // Fall angle: 75-105 degrees (closer to 90 for vertical)
                                        // (was 70-110)
    } else if (edge === 1) { // Start from Left
      startXPercent = -5;
      startYPercent = Math.random() * 50; // Slightly narrower vertical start range
      // --- MORE DOWNWARDS ANGLE ---
      angleDeg = Math.random() * 20 + 55; // Fall angle: 55-75 degrees (more downwards-right)
                                        // (was 30-60)
    } else { // Start from Right
      startXPercent = 105;
      startYPercent = Math.random() * 50; // Slightly narrower vertical start range
      // --- MORE DOWNWARDS ANGLE ---
      angleDeg = Math.random() * 20 + 105; // Fall angle: 105-125 degrees (more downwards-left)
                                         // (was 120-150)
    }

    const rotationDeg = angleDeg - 90;
    const angleRad = angleDeg * (Math.PI / 180);

    // Adjust travel distance if needed, ensure it covers enough vertical space quickly
    // For faster stars, they might not need to travel as far in terms of total hypotenuse
    // but we need to ensure they cross the screen.
    // A simpler approach for primarily vertical movement might be to ensure Y travel is at least 100vh + startY.
    const travelDistanceY = window.innerHeight * 1.1 + Math.abs(startYPercent / 100 * window.innerHeight);
    const travelDistanceX = travelDistanceY / Math.tan(angleRad); // Calculate X based on Y and angle
    const travelDistancePixels = Math.hypot(travelDistanceX, travelDistanceY);


    const deltaX = travelDistancePixels * Math.cos(angleRad);
    const deltaY = travelDistancePixels * Math.sin(angleRad);

    const initialAnimStyle = {
      '--star-color': starColor,
      '--tail-length': `${tailLength}px`,
      top: `${startYPercent}vh`,
      left: `${startXPercent}vw`,
      opacity: 1,
      transform: `rotate(${rotationDeg}deg) translate(0px, 0px)`,
      transition: `transform ${animationDuration}s ease-in, opacity ${animationDuration * 0.7}s ease-in ${animationDuration * 0.3}s`,
    };

    setCurrentStyle(initialAnimStyle);

    const animTriggerTimer = setTimeout(() => {
      if (starRef.current) {
        setCurrentStyle(prev => ({
          ...prev,
          opacity: 0,
          transform: `rotate(${rotationDeg}deg) translate(${deltaX}px, ${deltaY}px)`,
        }));
      }
    }, 30);

    const cleanupTimer = setTimeout(() => {
      onComplete(id);
    }, animationDuration * 1000 + 200);

    return () => {
      clearTimeout(animTriggerTimer);
      clearTimeout(cleanupTimer);
    };
  }, [id, onComplete]);

  return <div ref={starRef} className="shooting-star" style={currentStyle}></div>;
};

export default ShootingStar;